"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeatureGridCard;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _iconsSet = _interopRequireDefault(require("./icons-set"));
var _image = require("@site/pattern-library-core/image");
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CardContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardContainer",
  class: "pl-cb1bv7p"
});
const Card = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Card",
  class: "pl-cx94nwg",
  vars: {
    "cx94nwg-2": [({
      backgroundColor = 'initial'
    }) => backgroundColor]
  }
});
const CardShared = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardShared",
  class: "pl-c169uowf"
});
const FrontSide = /*#__PURE__*/(0, _react2.styled)(CardShared)({
  name: "FrontSide",
  class: "pl-f5zuoij"
});
const BackSide = /*#__PURE__*/(0, _react2.styled)(CardShared)({
  name: "BackSide",
  class: "pl-b1gsqtkt"
});
const FrontText = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FrontText",
  class: "pl-f18voe1d"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconWrapper",
  class: "pl-ihw2uzw"
});
const BackText = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BackText",
  class: "pl-bafqxxb"
});
const ImageWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageWrapper",
  class: "pl-ibcmyfu"
});
const ButtonContainer = /*#__PURE__*/(0, _react2.styled)(CardShared)({
  name: "ButtonContainer",
  class: "pl-bd384rt"
});
const ControlIcons = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "ControlIcons",
  class: "pl-cyl0phh"
});
const back = "pl-b13ev64u";
const item = {
  pre: {
    opacity: 0
  },
  active: {
    opacity: 1
  }
};

/**
 * FeatureGridCardSection component.
 *
 * @param {object} props React props
 * @param {object} props.backgroundColor Color of the tile
 * @param {string} props.frontTitle Front Side Heading
 * @param {string} props.frontDescription Front Side Description
 * @param {object} props.image Image Url and Alt text
 * @param {string} props.backText Back Side Text
 * @param {string} props.backIcon Back Side Icon
 * @returns {React.ReactElement} FeatureGridCard component
 * @public
 */

function FeatureGridCard({
  backgroundColor,
  frontTitle,
  frontDescription,
  frontImage = {},
  backText,
  backIcon,
  frontButtonARIALabel = 'open',
  backButtonARIALabel = 'close'
}) {
  const [rotation, setRotation] = (0, _react.useState)(null);
  const handleKeyPress = ({
    key
  }) => {
    if (key === 'Enter') {
      setRotation(!rotation);
    }
  };
  function handleClick() {
    setRotation(!rotation);
  }
  const {
    url,
    altText,
    height,
    width
  } = frontImage;
  // eslint-disable-next-line no-nested-ternary
  const className = `animate ${rotation ? 'active' : rotation === false ? 'passive' : ''}`;
  return /*#__PURE__*/_react.default.createElement(CardContainer, {
    variants: item,
    "data-cy": "grid-card"
  }, /*#__PURE__*/_react.default.createElement(Card, {
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    onClick: handleClick,
    onKeyPress: e => handleKeyPress(e),
    tabIndex: 0,
    className: className
  }, /*#__PURE__*/_react.default.createElement(FrontSide, {
    className: "face",
    tabIndex: -1
  }, /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
    url: url,
    altText: altText,
    height: height,
    width: width
  })), /*#__PURE__*/_react.default.createElement(FrontText, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    text: frontTitle
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 2,
    text: frontDescription
  })), /*#__PURE__*/_react.default.createElement(ButtonContainer, null, /*#__PURE__*/_react.default.createElement(ControlIcons, {
    tabIndex: -1,
    onClick: () => setRotation(!rotation),
    "aria-label": frontButtonARIALabel
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "information"
  }))))), /*#__PURE__*/_react.default.createElement(BackSide, {
    className: "face back"
  }, /*#__PURE__*/_react.default.createElement(BackText, null, /*#__PURE__*/_react.default.createElement(_iconsSet.default, {
    icon: backIcon
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 2,
    className: back,
    text: backText
  })), /*#__PURE__*/_react.default.createElement(ButtonContainer, null, /*#__PURE__*/_react.default.createElement(ControlIcons, {
    tabIndex: -1,
    onClick: () => setRotation(!rotation),
    "aria-label": backButtonARIALabel
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "delete"
  })))))));
}
FeatureGridCard.propTypes = {
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  frontTitle: _propTypes.default.string,
  frontDescription: _propTypes.default.string,
  frontImage: _propTypes.default.shape(_image.imgPropShape),
  backText: _propTypes.default.string,
  backIcon: _propTypes.default.string,
  frontButtonARIALabel: _propTypes.default.string,
  backButtonARIALabel: _propTypes.default.string
};